import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import LicensePrototypeForm from "./LicensePrototypeForm";
import * as Yup from "yup";
import * as actions from './store/licensePrototypeActions';
import History from "../../../History";
import { snackActions } from '../../sc-utilities/SnackBar';
import { hasPermission } from "../../sc-utilities";
import { CircularProgress } from "@material-ui/core";
import { CancelToken } from 'axios';

export const usedFor = [
    { value: 'cloud', label: 'Cloud access' },
    { value: 'commandStation', label: 'Command Station' },
    { value: 'mobileEraseStation', label: 'Mobile station' },
    { value: 'chatApp', label: 'Securaze chat application' },
    { value: 'onPremiseServer', label: 'On premise server' },
    { value: 'customerAutoCreate', label: 'Customer auto create' },
    { value: 'workDongle', label: 'Work Dongle' }
];

const LicensePrototypeCreate = props => {
    const { activeCustomerID, translations, permissions, onCreateLicensePrototype, onListPermissions } = props;
    const [createData, setCreateData] = useState({ permissions: [], loadingData: true });

    useEffect(() => {
        const requestToken = CancelToken.source();
        const fetchData = async () => {
            let permissions = await onListPermissions({ ActiveCustomerID: activeCustomerID }, { CancelToken: requestToken.token });
            if (permissions instanceof Array && permissions.length < 1) {
                snackActions.snackBarComponent("No permissions found, cannot select permissions.", "info");
            }
            setCreateData({ loadingData: false, permissions: permissions });
        };
        fetchData();
        return () => {
            requestToken.cancel('Operation canceled by the user.');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const extractUsedFor = selectedUsedFor => {
        return selectedUsedFor.map(usedFor => usedFor.value);
    }

    const extractPermissions = selectedPermission => {
        return selectedPermission.map(permission => permission.value);
    }

    const handleSubmit = async data => {
        let formData = {};
        const configuration = JSON.stringify({
            UsedFor: extractUsedFor(data.UsedFor),
            Permissions: extractPermissions(data.Permissions),
            Hardware: data.Hardware
        });
        formData['Name'] = data.Name;
        formData['Configuration'] = configuration;
        formData['Hardware'] = data.Hardware;

        let result = await onCreateLicensePrototype({ ...formData, ActiveCustomerID: activeCustomerID });
        if (result) {
            History.goBack();
        }
    };

    let initialValues = {
        Name: "",
        Hardware: "",
        UsedFor: [],
        Permissions: [],
    };
    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
        },
        FormTitle: translations["create_license_prototype"] || "Create license prototype",
        ButtonSubmit: hasPermission(permissions, 'license_prototype_create') ? {
            Title: translations["save"] || "SAVE"
        } : null,
    };

    return !createData.loadingData ?
        <LicensePrototypeForm
            formSettings={formSettings}
            initialValues={initialValues}
            handleSubmit={handleSubmit}
            permissions={createData.permissions}
            translations={translations}
            usedFor={usedFor}
        /> : <CircularProgress />;
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || []
    };
};
const mapDispatchToProps = dispatch => {
    return {
        onCreateLicensePrototype: licensePrototype => dispatch(actions.createLicensePrototype(licensePrototype)),
        onListPermissions: (id) => dispatch(actions.listPermissions(id))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LicensePrototypeCreate);